<template>
  <v-card outlined tile :loading="loading" :disabled="loading">
    <v-card-title class="subtitle-1 font-weight-bold pb-1">
      Test Type Filter
    </v-card-title>
    <v-card-subtitle class="caption text--secondary">
      Select test types to filter out from test buttons, dropdowns, and selections across the app.
    </v-card-subtitle>
    <v-card-text>
      <v-autocomplete
        v-model="selectedTestTypes"
        :items="sampleTestTypes"
        item-text="name"
        item-value="uuid"
        label="Test Types to Filter Out"
        multiple
        chips
        deletable-chips
        outlined
        dense
        clearable
        hide-details="auto"
        placeholder="Search and select test types..."
      >
        <template v-slot:selection="{ item, selected }">
          <v-chip
            :input-value="selected"
            close
            @click:close="removeTestType(item.uuid)"
            color="primary"
            class="white--text ma-1"
            small
          >
            <strong>{{ item.name }}</strong>
          </v-chip>
        </template>
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-action>
              <v-simple-checkbox :value="selectedTestTypes.includes(item.uuid)"></v-simple-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <span class="font-weight-bold mr-2">{{ item.name }}</span>
                <span class="caption text--secondary" v-if="item.description">
                  - {{ item.description }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-card-text>
    <v-card-actions class="px-4 pb-3">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        tile
        small
        :loading="saving"
        :disabled="saving || loading"
        @click="saveFilteredTestTypes"
      >
        Save Test Type Filter
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "TestTypeFilter",
  data() {
    return {
      selectedTestTypes: [],
      loading: false,
      saving: false,
    };
  },
  computed: {
    sampleTestTypes() {
      return this.$store.$db().model('sampleTestTypes').query().orderBy("display_order").all();
    }
  },
  async mounted() {
    await this.loadFilteredTestTypes();
  },
  methods: {
    removeTestType(uuid) {
      this.selectedTestTypes = this.selectedTestTypes.filter(id => id !== uuid);
    },
    async loadFilteredTestTypes() {
      this.loading = true;
      try {
        if (this.$store.$db().model('sampleTestTypes').all().length === 0) {
          await this.$store.$db().model('sampleTestTypes').api().fetch();
        }
        const doc = await this.$firestore.collection("Configs").doc("Belit").get();
        if (doc.exists) {
          const data = doc.data();
          this.selectedTestTypes = data.filtered_test_types || [];
          this.$store.commit('setFilteredTestTypes', this.selectedTestTypes);
        } else {
          this.selectedTestTypes = this.$store.state.filtered_test_types || [];
        }
      } catch (e) {
        console.error("Failed to load test type filter config:", e);
        this.$store.dispatch("showError", "Failed to load test type filter settings");
      } finally {
        this.loading = false;
      }
    },
    async saveFilteredTestTypes() {
      this.saving = true;
      try {
        await this.$firestore.collection("Configs").doc("Belit").set({
          filtered_test_types: this.selectedTestTypes,
        }, { merge: true });

        this.$store.commit('setFilteredTestTypes', this.selectedTestTypes);
        this.$store.dispatch("showSuccess", "Test type filter saved successfully");
      } catch (e) {
        console.error("Failed to save test type filter config:", e);
        this.$store.dispatch("showError", "Failed to save test type filter settings");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
</style>
